/**
 * CITY_ROWS — the three served metros with their per-city hue accents
 * (contained to metro pickers/pills; the app body stays pure-trio).
 * Extracted from MetroPickerPage when the /metro route was retired
 * (plan R2-5, 2026-07-07) — the home hero's metro pills are the gate now.
 */
export const CITY_ROWS: Array<{
  key: string;
  emoji: string;
  tagline: string;
  accent: string; // per-city hue, contained to the metro pickers
  glow: string;
}> = [
  { key: 'Austin', emoji: '🎸', tagline: 'Live Music Capital of the World', accent: '#FFD24D', glow: 'rgba(255, 200, 60, 0.35)' },
  { key: 'Dallas', emoji: '🤠', tagline: 'Big D, big options', accent: '#B98CFF', glow: 'rgba(185, 140, 255, 0.3)' },
  { key: 'Houston', emoji: '🚀', tagline: 'Space City, space for you', accent: '#35E0C8', glow: 'rgba(53, 224, 200, 0.3)' },
];

/** T12 — the hero submits with zero interaction, so a metro is always
 *  selected. Austin is the default (largest inventory, the launch market);
 *  the pills stay as a one-tap override. */
export const DEFAULT_METRO = 'Austin';

